(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xt-bn-studio"] && !Shopify.designMode) return;
  try {
    if (!window.xtBnStudioReady) {
  window.xtBnStudioReady = true;
  const code = 'TAXFREE';
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let toastTimer;
  const buttons = () => Array.from(document.querySelectorAll('[data-bns-activate]'));
  const stateOf = cart => {
    const entry = (cart.discount_codes || []).find(d => String(d.code).toUpperCase() === code);
    const allocations = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(i => (i.line_level_discount_allocations || []).map(d => d.discount_application))];
    const applied = entry?.applicable === true || allocations.some(d => String(d?.title).toUpperCase() === code);
    return applied ? 'applied' : entry ? 'saved' : 'inactive';
  };
  const updateButtons = state => {
    buttons().forEach(button => {
      button.dataset.state = state;
      button.querySelector('[data-bns-button-label]').textContent = state === 'applied' ? button.dataset.active : button.dataset.label;
    });
  };
  const getCart = async () => {
    const response = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error('cart');
    return response.json();
  };
  const notify = (button, state) => {
    let toast = document.querySelector('.bns-activation-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bns-activation-toast';
      toast.dir = 'rtl';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.setAttribute('aria-atomic', 'true');
      toast.append(document.createElement('strong'), document.createElement('p'));
      document.body.append(toast);
    }
    toast.dataset.state = state;
    toast.querySelector('strong').textContent = state === 'applied' ? button.dataset.success : state === 'saved' ? button.dataset.saved : button.dataset.error;
    toast.querySelector('p').textContent = state === 'applied' ? button.dataset.successNote : state === 'saved' ? button.dataset.savedNote : button.dataset.errorNote;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 6500);
  };
  const celebrate = () => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelector('.bns-confetti')?.remove();
    const layer = document.createElement('div');
    layer.className = 'bns-confetti';
    layer.setAttribute('aria-hidden', 'true');
    document.body.append(layer);
    const colors = ['#b58a54', '#d8b995', '#8e5e42', '#e8d8bc', '#25221e'];
    for (let i = 0; i < 42; i++) {
      const piece = document.createElement('i');
      piece.style.background = colors[i % colors.length];
      piece.style.left = (22 + Math.random() * 56) + '%';
      piece.style.top = (16 + Math.random() * 15) + '%';
      layer.append(piece);
      piece.animate([
        {transform: 'translate(0,0) rotate(0deg)', opacity: 0},
        {opacity: 1, offset: .12},
        {transform: `translate(${(Math.random() - .5) * 480}px,${280 + Math.random() * 270}px) rotate(${Math.random() * 850}deg)`, opacity: 0}
      ], {duration: 1400 + Math.random() * 500, easing: 'cubic-bezier(.15,.6,.45,1)', fill: 'forwards'});
    }
    setTimeout(() => layer.remove(), 2100);
  };
  document.addEventListener('click', async event => {
    const terms = event.target.closest('[data-bns-terms]');
    const dialog = document.querySelector('#bn-studio-terms');
    if (terms && dialog) { event.preventDefault(); dialog.showModal(); }
    if (event.target.closest('[data-bns-close]')) dialog?.close();
    if (event.target === dialog) {
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    }
    const button = event.target.closest('[data-bns-activate]');
    if (!button || busy) return;
    event.preventDefault();
    busy = true;
    buttons().forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    button.querySelector('[data-bns-button-label]').textContent = button.dataset.loading;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', signal: controller.signal,
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({discount: code})
      });
      if (!response.ok) throw new Error('discount');
      const cart = await response.json();
      const state = stateOf(cart);
      updateButtons(state);
      document.dispatchEvent(new CustomEvent('theme:cart:change', {detail: {cart}, bubbles: true}));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (state === 'inactive') throw new Error('not-accepted');
      notify(button, state);
      if (state === 'applied') celebrate();
    } catch {
      button.querySelector('[data-bns-button-label]').textContent = button.dataset.label;
      notify(button, 'error');
    } finally {
      clearTimeout(timer);
      busy = false;
      buttons().forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
    }
  });
  const sync = () => getCart().then(cart => updateButtons(stateOf(cart))).catch(() => {});
  document.addEventListener('theme:cart:change', event => {
    if (event.detail?.cart) updateButtons(stateOf(event.detail.cart));
  });
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('pageshow', sync);
  sync();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xt26-cookie-consent"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('xt26-cookie-consent'))customElements.define('xt26-cookie-consent',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;
    this.ready=true;this.manualOpen=false;
    try{this.dismissed=sessionStorage.getItem("xtazy-cookie-dismissed")==="1";}catch{this.dismissed=false;}
    this.controller=new AbortController();
    this.banner=this.querySelector('[data-cookie-banner]');
    this.error=this.querySelector('[data-cookie-error]');
    this.closeButton=this.querySelector('[data-cookie-close]');
    this.opener=this.querySelector('[data-cookie-open]');
    const signal=this.controller.signal;
    this.addEventListener('click',event=>{
      if(event.target.closest('[data-cookie-open]')){
        this.dismissed=false;this.manualOpen=true;
        try{sessionStorage.removeItem('xtazy-cookie-dismissed');}catch{}
        this.banner.hidden=false;this.error.textContent='';
        this.querySelector('[data-cookie-choice]').focus({preventScroll:true});
        this.ensureAPI().catch(()=>{if(!this.busy&&this.manualOpen)this.error.textContent=this.dataset.error;});
      }
      if(event.target.closest('[data-cookie-close]'))this.dismiss();
      const choice=event.target.closest('[data-cookie-choice]');
      if(choice)this.save(choice.dataset.cookieChoice==='accept');
    },{signal});
    this.addEventListener('keydown',event=>{if(event.key==='Escape'&&!this.banner.hidden){event.preventDefault();this.dismiss();}},{signal});
    document.addEventListener('visitorConsentCollected',()=>{if(this.api&&!this.busy&&this.hasConsent()){this.rememberDecision();if(!this.manualOpen)this.banner.hidden=true;this.error.textContent='';this.syncGoogleSafely();}},{signal});
    window.addEventListener('storage',event=>{if(event.key==='xtazy-cookie-decision-v1')this.updateVisibility();},{signal});
    this.ensureAPI().then(()=>{
      if(this.hasConsent()&&!this.hasRememberedDecision())this.rememberDecision();
      this.updateVisibility();
      this.syncGoogleSafely();
    }).catch(()=>{this.updateVisibility();});
  }
  disconnectedCallback(){this.controller?.abort();clearTimeout(this.retryTimer);this.ready=false;}
  dismiss(){
    this.dismissed=true;this.manualOpen=false;this.banner.hidden=true;
    try{sessionStorage.setItem('xtazy-cookie-dismissed','1');}catch{}
    this.opener.focus({preventScroll:true});
  }
  hasRememberedDecision(){
    const values=[];
    try{values.push(localStorage.getItem('xtazy-cookie-decision-v1'));}catch{}
    try{values.push(sessionStorage.getItem('xtazy-cookie-decision-v1'));}catch{}
    try{values.push(document.cookie.split('; ').find(value=>value.startsWith('xtazy_cookie_decision_v1='))?.split('=')[1]);}catch{}
    return values.some(value=>/^1:\d+$/.test(value||'')&&Number(value.slice(2))>Date.now());
  }
  rememberDecision(){
    const maxAge=15552000;
    const value='1:'+(Date.now()+maxAge*1000);
    try{localStorage.setItem('xtazy-cookie-decision-v1',value);}catch{}
    try{sessionStorage.setItem('xtazy-cookie-decision-v1',value);}catch{}
    try{document.cookie='xtazy_cookie_decision_v1='+value+'; Path=/; Max-Age='+maxAge+'; SameSite=Lax; Secure';}catch{}
  }
  updateVisibility(){
    if(!this.manualOpen)this.banner.hidden=this.dismissed||this.hasRememberedDecision()||this.hasConsent();
  }
  hasConsent(accepted){
    try{
      const state=this.api?.currentVisitorConsent();
      return !!state&&['analytics','marketing','preferences'].every(key=>accepted===undefined?(state[key]==='yes'||state[key]==='no'):state[key]===(accepted?'yes':'no'));
    }catch{return false;}
  }
  ensureAPI(){
    const available=()=>{
      const api=window.Shopify?.customerPrivacy;
      return typeof api?.setTrackingConsent==='function'&&typeof api?.currentVisitorConsent==='function'?api:null;
    };
    const ready=available();
    if(ready){this.api=ready;return Promise.resolve(ready);}
    if(this.loading)return this.loading;
    this.loading=new Promise((resolve,reject)=>{
      let settled=false,requested=false;
      const timeout=setTimeout(()=>finish(new Error('Privacy API unavailable')),15000);
      const finish=error=>{
        if(settled)return;
        const api=available();
        if(!error&&!api)return;
        settled=true;clearTimeout(timeout);clearTimeout(this.retryTimer);
        if(!api){reject(error);return;}
        this.api=api;resolve(api);
      };
      const load=()=>{
        if(settled)return;
        if(!this.isConnected){finish(new Error('Consent controls disconnected'));return;}
        if(available()){finish();return;}
        try{
          if(!requested&&typeof window.Shopify?.loadFeatures==='function'){
            requested=true;
            window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{
              if(available())finish();
              else if(error)finish(error);
            });
          }
        }catch(error){finish(error);}
        if(!settled)this.retryTimer=setTimeout(load,200);
      };
      load();
    }).finally(()=>{this.loading=null;});
    return this.loading;
  }
  writeConsent(api,accepted){
    return new Promise((resolve,reject)=>{
      let settled=false,pollTimer;
      const finish=error=>{
        if(settled)return;
        settled=true;clearTimeout(timeout);clearTimeout(pollTimer);
        document.removeEventListener('visitorConsentCollected',onConsent);
        if(error&&!this.hasConsent(accepted))reject(error);else resolve();
      };
      const onConsent=()=>{if(this.hasConsent(accepted))finish();};
      const timeout=setTimeout(()=>finish(new Error('Consent request timed out')),12000);
      const poll=()=>{
        if(settled)return;
        if(this.hasConsent(accepted)){finish();return;}
        pollTimer=setTimeout(poll,200);
      };
      document.addEventListener('visitorConsentCollected',onConsent);
      try{
        api.setTrackingConsent({analytics:accepted,marketing:accepted,preferences:accepted},result=>{
          if(result?.error){finish(new Error('Consent not saved'));return;}
          finish();
        });
        if(!settled)poll();
      }catch(error){finish(error);}
    });
  }
  syncGoogleSafely(){
    try{this.syncGoogle();}catch(error){console.warn('XTAZY consent saved; measurement sync unavailable',error);}
  }
  syncGoogle(){
    if(!this.api)return;
    const consent=this.api.currentVisitorConsent();
    const analytics=consent.analytics==='yes'&&this.api.analyticsProcessingAllowed?.()===true;
    const marketing=consent.marketing==='yes'&&this.api.marketingAllowed?.()===true;
    window.gtag?.('consent','update',{analytics_storage:analytics?'granted':'denied',ad_storage:marketing?'granted':'denied',ad_user_data:marketing?'granted':'denied',ad_personalization:marketing?'granted':'denied'});
    if((analytics||marketing)&&!document.querySelector('script[data-xt26-google]')){
      const script=document.createElement('script');script.async=true;script.src='https://www.googletagmanager.com/gtag/js?id=GT-MQJQ7KSD';script.dataset.xt26Google='';document.head.append(script);
      window.gtag?.('js',new Date());window.gtag?.('config','GT-MQJQ7KSD');
    }
  }
  async save(accepted){
    if(this.busy)return;
    this.busy=true;this.error.textContent='';
    const buttons=[...this.querySelectorAll('[data-cookie-choice]')];buttons.forEach(button=>button.disabled=true);
    this.banner.setAttribute('aria-busy','true');
    const restoreFocus=this.banner.contains(document.activeElement);
    try{
      for(let attempt=0;attempt<2;attempt++){
        try{
          const api=await this.ensureAPI();
          await this.writeConsent(api,accepted);
          break;
        }catch(error){
          if(attempt===1||!this.isConnected)throw error;
          await new Promise(resolve=>setTimeout(resolve,500));
        }
      }
      this.rememberDecision();this.manualOpen=false;this.banner.hidden=true;this.error.textContent='';
      this.syncGoogleSafely();
      if(restoreFocus)document.activeElement?.blur();
    }catch{this.banner.hidden=this.dismissed;this.error.textContent=this.dataset.error;}
    finally{this.busy=false;buttons.forEach(button=>button.disabled=false);this.banner.removeAttribute('aria-busy');}
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xt26-quick-add"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('xt26-quick-add'))customElements.define('xt26-quick-add',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.controller=new AbortController();
    this.groups=[...this.querySelectorAll('.xq-group')];this.selected=this.groups.map(()=>null);this.addButton=this.querySelector('[data-xq-add]');this.status=this.querySelector('.xq-status');this.price=this.querySelector('[data-xq-price]');
    this.product={variants:JSON.parse(this.querySelector('[data-xq-variants]').textContent)};this.resolve();
    this.addEventListener('click',e=>{const option=e.target.closest('.xq-option');if(option){e.preventDefault();e.stopPropagation();this.select(option);}if(e.target.closest('[data-xq-add]')){e.preventDefault();e.stopPropagation();this.add();}},{signal:this.controller.signal});
  }
  disconnectedCallback(){this.controller?.abort();this.ready=false;}
  async catalog(){if(this.product)return this.product;const url=new URL(this.dataset.url,document.baseURI);url.pathname+='.js';url.search='';url.hash='';if(!this.pending)this.pending=fetch(url,{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw new Error();return r.json();}).then(p=>{this.product=p;return p;}).catch(e=>{this.pending=null;throw e;});return this.pending;}
  async select(button){
    if(this.busy||button.disabled||button.hidden)return;const group=button.closest('.xq-group');const position=Number(group.dataset.position);const visible=[...group.querySelectorAll('button')].filter(b=>!b.hidden&&!b.disabled);this.selected[position]=visible.length===1?button.dataset.value:this.selected[position]===button.dataset.value?null:button.dataset.value;for(let i=position+1;i<this.selected.length;i++)this.selected[i]=null;this.addButton.disabled=true;this.status.textContent=this.dataset.loading;
    try{await this.catalog();if(!this.isConnected)return;this.resolve();this.status.textContent='';}catch(e){this.status.textContent=this.dataset.error;}
  }
  resolve(){
    this.groups.forEach((group,index)=>{
      const buttons=[...group.querySelectorAll('button')];
      buttons.forEach(button=>{
        const possible=this.product.variants.some(v=>v.available&&v.options[index]===button.dataset.value&&this.selected.every((value,i)=>i>=index||value===null||v.options[i]===value));
        button.hidden=!possible;button.disabled=!possible;
      });
      const available=buttons.filter(button=>!button.hidden);
      if(!available.some(button=>button.dataset.value===this.selected[index]))this.selected[index]=null;
      if(available.length===1)this.selected[index]=available[0].dataset.value;
      buttons.forEach(button=>button.setAttribute('aria-pressed',String(!button.hidden&&button.dataset.value===this.selected[index])));
    });
    const complete=this.selected.every(value=>value!==null);this.variant=this.groups.length===0?this.product.variants.find(v=>v.available):complete?this.product.variants.find(v=>v.available&&v.options.every((value,i)=>value===this.selected[i])):null;
    this.addButton.disabled=!this.variant?.available;this.addButton.textContent=this.variant?(this.variant.available?this.dataset.add:this.dataset.sold):this.dataset.choose;
    const cardPrice=this.closest('.xc')?.querySelector('[data-xc-price]');if(cardPrice){if(!this.basePrice)this.basePrice=cardPrice.innerHTML;if(this.variant){const money=n=>new Intl.NumberFormat(document.documentElement.lang||'he-IL',{style:'currency',currency:this.dataset.currency}).format(n/100);const now=document.createElement('bdi');now.textContent=money(this.variant.price);cardPrice.replaceChildren(now);if(this.variant.compare_at_price>this.variant.price){const old=document.createElement('s');old.textContent=money(this.variant.compare_at_price);cardPrice.append(old);}}else cardPrice.innerHTML=this.basePrice;}
    this.price.hidden=!this.variant||this.dataset.priceVaries!=='true';if(this.variant)this.price.textContent=new Intl.NumberFormat(document.documentElement.lang||'he-IL',{style:'currency',currency:this.dataset.currency}).format(this.variant.price/100);
  }
  async add(){
    if(this.busy||!this.variant?.available)return;this.busy=true;this.addButton.disabled=true;this.addButton.setAttribute('aria-busy','true');this.status.textContent=this.dataset.loading;
    try{
      const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:1}],sections:['xt26-cart-content'],sections_url:this.dataset.cartUrl})});
      const data=await response.json();if(!response.ok)throw new Error(data.description||this.dataset.error);this.status.textContent=this.dataset.added;
      document.dispatchEvent(new CustomEvent('xt26:cart-added',{detail:{html:data.sections?.['xt26-cart-content'],trigger:this.addButton}}));
    }catch(error){this.status.textContent=error.message||this.dataset.error;this.product=null;this.pending=null;}
    finally{this.busy=false;this.addButton.disabled=!this.variant?.available;this.addButton.removeAttribute('aria-busy');}
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xt26-typography"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('xt26-cart-coupon'))customElements.define('xt26-cart-coupon',class extends HTMLElement{
  connectedCallback(){if(this.ready)return;this.ready=true;this.controller=new AbortController();const signal=this.controller.signal;this.input=this.querySelector('[data-xc-input]');this.addEventListener('click',event=>{const apply=event.target.closest('[data-xc-apply]'),remove=event.target.closest('[data-xc-remove]');if(apply||remove){event.preventDefault();this.apply(remove?remove.dataset.xcRemove:null);}},{signal});this.input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();event.stopPropagation();this.apply(null);}},{signal});if(this.dataset.context==='page'){try{const flash=JSON.parse(sessionStorage.getItem('xt26-coupon-flash')||'null');sessionStorage.removeItem('xt26-coupon-flash');if(flash&&Date.now()-flash.time<30000)this.message(flash.message,flash.success);}catch{}}}
  disconnectedCallback(){this.controller?.abort();this.ready=false;}
  message(text,success=false){const status=this.querySelector('[data-xc-status]');status.textContent=text;status.toggleAttribute('data-success',success);}
  codes(cart){return [...new Set([...(cart.discount_codes||[]).filter(c=>c.applicable!==false).map(c=>c.code),...(cart.cart_level_discount_applications||[]).filter(d=>d.type==='discount_code').map(d=>d.title),...(cart.items||[]).flatMap(item=>(item.line_level_discount_allocations||[]).filter(d=>d.discount_application?.type==='discount_code').map(d=>d.discount_application.title))].filter(Boolean))];}
  async apply(remove){const header=document.querySelector('xt26-header');if(this.busy||header?.cartBusy||header?.cartLoading)return;const entered=this.input.value.trim();if(remove===null&&!entered){this.message(this.dataset.empty);this.input.focus();return;}this.busy=true;if(header)header.cartBusy=true;this.message(this.dataset.loading);const form=this.closest('form'),controls=[...(form?.querySelectorAll('button,input')||[])].map(el=>[el,el.disabled]);controls.forEach(([el])=>el.disabled=true);this.setAttribute('aria-busy','true');
    try{const currentResponse=await fetch(this.dataset.cartUrl+'.js',{cache:'no-store',headers:{Accept:'application/json'}});if(!currentResponse.ok)throw new Error();const current=await currentResponse.json();let codes=this.codes(current);if(remove!==null)codes=codes.filter(c=>c.toLowerCase()!==remove.toLowerCase());else if(!codes.some(c=>c.toLowerCase()===entered.toLowerCase()))codes.push(entered);
      const response=await fetch(this.dataset.updateUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:codes.join(','),sections:['xt26-cart-content'],sections_url:this.dataset.cartUrl})});const cart=await response.json();if(!response.ok)throw new Error();const accepted=remove!==null||this.codes(cart).some(c=>c.toLowerCase()===entered.toLowerCase());const message=remove!==null?this.dataset.removed:accepted?this.dataset.success:this.dataset.invalid;
      if(this.dataset.context==='page'){try{sessionStorage.setItem('xt26-coupon-flash',JSON.stringify({message,success:accepted,time:Date.now()}));}catch{}location.reload();return;}
      if(header){if(cart.sections?.['xt26-cart-content'])header.renderCart(cart.sections['xt26-cart-content']);else{header.cartBusy=false;await header.loadCart();header.cartBusy=true;}header.setCount(cart.item_count);const fresh=header.querySelector('xt26-cart-coupon');if(fresh){fresh.message(message,accepted);if(!accepted)fresh.input.value=entered;fresh.input.focus({preventScroll:true});}}
      document.dispatchEvent(new CustomEvent('theme:cart:change',{detail:{cart},bubbles:true}));
    }catch{this.message(this.dataset.error);}finally{this.busy=false;if(header)header.cartBusy=false;this.removeAttribute('aria-busy');controls.forEach(([el,disabled])=>{if(el.isConnected)el.disabled=disabled;});}
  }
});


if(!customElements.get('xt26-shipping-progress'))customElements.define('xt26-shipping-progress',class extends HTMLElement{
  connectedCallback(){this.controller?.abort();this.controller=new AbortController();document.addEventListener('theme:cart:change',event=>{if(event.detail?.cart)this.update(event.detail.cart);},{signal:this.controller.signal});}
  disconnectedCallback(){this.controller?.abort();}
  update(cart){const limit=Number(this.dataset.threshold);this.hidden=!cart.requires_shipping||cart.currency!==this.dataset.currency;if(this.hidden||limit<=0)return;const remaining=Math.max(0,limit-cart.total_price),percent=Math.min(100,Math.max(0,cart.total_price/limit*100));const amount=new Intl.NumberFormat('he-IL',{style:'currency',currency:cart.currency,maximumFractionDigits:2}).format(remaining/100);this.querySelector('[data-xs-message]').textContent=remaining?this.dataset.more.replace('__AMOUNT__',amount):this.dataset.done;const bar=this.querySelector('[role=progressbar]');bar.setAttribute('aria-valuenow',String(Math.round(percent)));bar.firstElementChild.style.width=percent+'%';}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xt26-variant-guard"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('xt26-variant-guard'))customElements.define('xt26-variant-guard',class extends HTMLElement{
  connectedCallback(){
    this.root=this.closest('[data-product-form-wrapper]');this.form=document.getElementById(this.dataset.form);
    if(!this.root||!this.form)return;
    this.groups=[...this.root.querySelectorAll('[data-xvg-option]')];if(!this.groups.length)return;
    this.abort=new AbortController();const options={signal:this.abort.signal};
    this.root.addEventListener('change',()=>queueMicrotask(()=>this.sync()),options);
    this.root.addEventListener('theme:variant:change',()=>this.sync(),options);
    this.root.addEventListener('submit',event=>{if(this.pending()){event.preventDefault();event.stopImmediatePropagation();this.sync();this.groups.find(group=>!group.querySelector('input:checked'))?.querySelector('input')?.focus();}},{...options,capture:true});
    this.sync();
  }
  disconnectedCallback(){this.abort?.abort();}
  pending(){return this.groups.some(group=>!group.querySelector('input:checked'));}
  sync(){
    const pending=this.pending();this.root.toggleAttribute('data-xvg-pending',pending);this.querySelector('.xvg-hint').hidden=!pending;
    if(!pending)return;
    this.form.querySelector('[name="id"]').value='';
    this.root.querySelectorAll('[data-add-to-cart]').forEach(button=>{button.disabled=true;const text=button.querySelector('[data-add-to-cart-text]');if(text)text.textContent=this.dataset.choose;});
    this.root.querySelectorAll('[data-product-price]').forEach(price=>{price.textContent=this.dataset.price;});
    this.groups.forEach(group=>{if(!group.querySelector('input:checked')){const label=group.querySelector('[data-option-value]');if(label)label.textContent=this.dataset.choose;}});
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xt27-service-request"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('xt27-service-request'))customElements.define('xt27-service-request',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.events=new AbortController();this.form=this.closest('form');this.sequence=new Map();this.pending=new Map();this.replacement=null;this.busy=false;this.locked=false;
    this.querySelector('[data-xsr-request-id]').value=crypto.randomUUID();
    this.addEventListener('click',e=>{const button=e.target.closest('[data-xsr-find]');if(button){e.preventDefault();e.stopPropagation();this.search(button.closest('[data-xsr-picker]'));}},{signal:this.events.signal});
    this.addEventListener('input',e=>{if(e.target.matches('[data-xsr-search]')){const picker=e.target.closest('[data-xsr-picker]');this.invalidate(picker);if(picker.dataset.xsrPicker==='replacement')this.clearReplacement();}},{signal:this.events.signal});
    this.addEventListener('change',e=>{if(e.target.matches('[data-xsr-variant]'))this.chooseVariant();},{signal:this.events.signal});
    this.addEventListener('keydown',e=>{if(e.key==='Enter'&&e.target.matches('[data-xsr-search]')){e.preventDefault();e.stopPropagation();this.search(e.target.closest('[data-xsr-picker]'));}},{signal:this.events.signal});
    this.form.addEventListener('click',e=>{const button=e.target.closest('[data-add-to-cart]');if(button){e.preventDefault();e.stopImmediatePropagation();this.submit(button);}},{capture:true,signal:this.events.signal});
    this.form.addEventListener('submit',e=>{e.preventDefault();e.stopImmediatePropagation();this.submit(this.form.querySelector('[data-add-to-cart]'));},{capture:true,signal:this.events.signal});
  }
  disconnectedCallback(){this.events?.abort();for(const controller of this.pending.values())controller.abort();this.ready=false;}
  invalidate(picker){this.sequence.set(picker,(this.sequence.get(picker)||0)+1);this.pending.get(picker)?.abort();picker.querySelector('[data-xsr-results]').hidden=true;picker.querySelector('[data-xsr-status]').textContent='';}
  clearReplacement(){this.replacement=null;const select=this.querySelector('[data-xsr-variant]');if(!select)return;select.replaceChildren(new Option(this.dataset.choose,''));for(const key of ['sku','variant-id','product-url'])this.querySelector(`[data-xsr-${key}]`).value='';}
  async search(picker){
    if(this.busy||this.locked)return;const input=picker.querySelector('[data-xsr-search]'),term=input.value.trim();this.invalidate(picker);
    const status=picker.querySelector('[data-xsr-status]');if(term.length<2){status.textContent=this.dataset.short;return;}
    const controller=new AbortController();this.pending.set(picker,controller);const sequence=this.sequence.get(picker);status.textContent=this.dataset.loading;
    const url=new URL(this.dataset.searchUrl,location.origin);url.search=new URLSearchParams({q:term,type:'product','options[prefix]':'last',section_id:'xt27-service-search'}).toString();
    try{
      const response=await fetch(url,{signal:controller.signal,credentials:'same-origin'});if(!response.ok)throw new Error();
      const html=new DOMParser().parseFromString(await response.text(),'text/html');const data=html.querySelector('[data-xsr-catalog]');if(!data)throw new Error();
      const products=JSON.parse(data.textContent).filter(p=>picker.dataset.xsrPicker==='original'||p.available);
      if(sequence!==this.sequence.get(picker)||!this.isConnected)return;
      const results=picker.querySelector('[data-xsr-results]');results.replaceChildren();results.hidden=products.length===0;
      for(const product of products){const button=document.createElement('button');button.type='button';button.className='xsr-result';if(product.image){const img=document.createElement('img');img.src=product.image;img.alt='';img.width=42;img.height=52;img.loading='lazy';button.append(img);}const title=document.createElement('span');title.textContent=product.title;button.append(title);button.addEventListener('click',()=>this.selectProduct(picker,product),{signal:this.events.signal});results.append(button);}
      status.textContent=products.length?'':this.dataset.empty;
    }catch(error){if(error.name!=='AbortError'&&sequence===this.sequence.get(picker))status.textContent=this.dataset.error;}
  }
  productURL(path){const url=new URL(path,location.origin);if(url.origin!==location.origin||!url.pathname.includes('/products/'))throw new Error();url.search='';url.hash='';url.pathname+='.js';return url;}
  async selectProduct(picker,product){
    if(this.busy||this.locked)return;this.invalidate(picker);if(picker.dataset.xsrPicker==='replacement')this.clearReplacement();const sequence=this.sequence.get(picker);const controller=new AbortController();this.pending.set(picker,controller);
    const status=picker.querySelector('[data-xsr-status]');status.textContent=this.dataset.loading;
    try{
      const response=await fetch(this.productURL(product.url),{signal:controller.signal,credentials:'same-origin'});if(!response.ok)throw new Error();const data=await response.json();
      if(sequence!==this.sequence.get(picker)||!this.isConnected)return;
      picker.querySelector('[data-xsr-search]').value=data.title;
      if(picker.dataset.xsrPicker==='original'){
        const list=picker.querySelector('[data-xsr-sizes]');list.replaceChildren();for(const variant of data.variants)list.append(new Option(variant.title,variant.title));picker.querySelector('[data-xsr-original-size]').focus();
      }else{
        this.clearReplacement();this.replacement={url:product.url,product:data};const select=picker.querySelector('[data-xsr-variant]');
        for(const variant of data.variants){const option=new Option(variant.title,variant.title);option.dataset.variantId=String(variant.id);option.disabled=!variant.available;if(!variant.available)option.textContent+=' — '+this.dataset.unavailable;select.append(option);}
        select.focus();
      }
      status.textContent=this.dataset.selected;
    }catch(error){if(error.name!=='AbortError'&&sequence===this.sequence.get(picker))status.textContent=this.dataset.error;}
  }
  chooseVariant(){
    const select=this.querySelector('[data-xsr-variant]'),id=select.selectedOptions[0]?.dataset.variantId;
    const variant=this.replacement?.product.variants.find(v=>String(v.id)===id&&v.available);
    this.querySelector('[data-xsr-variant-id]').value=variant?String(variant.id):'';
    this.querySelector('[data-xsr-sku]').value=variant?.sku||'';
    this.querySelector('[data-xsr-product-url]').value=variant?new URL(this.replacement.url,location.origin).pathname:'';
  }
  async submit(button){
    if(this.busy||this.locked||!button||button.disabled)return;
    for(const input of this.querySelectorAll('input[type=text],textarea'))input.value=input.value.trim();
    if(!this.form.reportValidity())return;
    const status=this.querySelector('[data-xsr-submit-status]');this.busy=true;button.disabled=true;button.setAttribute('aria-busy','true');status.textContent=this.dataset.loading;let sent=false;
    try{
      if(this.querySelector('[data-xsr-variant]')){
        const id=this.querySelector('[data-xsr-variant-id]').value;if(!this.replacement||!id)throw new Error(this.dataset.choose);
        const response=await fetch(this.productURL(this.replacement.url),{credentials:'same-origin'});if(!response.ok)throw new Error(this.dataset.error);const product=await response.json();
        const variant=product.variants.find(v=>String(v.id)===id&&v.available);if(!variant){this.clearReplacement();throw new Error(this.dataset.unavailable);}
      }
      const data=new FormData(this.form);data.set('sections','xt26-cart-content');data.set('sections_url',this.dataset.cartUrl);sent=true;
      const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',body:data,credentials:'same-origin',headers:{Accept:'application/json'}});
      if(!response.ok){sent=false;const error=await response.json();throw new Error(error.description||this.dataset.error);}
      const result=await response.json();this.locked=true;status.textContent=this.dataset.added;this.querySelector('[data-xsr-cart-link]').hidden=false;
      for(const control of this.querySelectorAll('input,select,textarea,button'))control.disabled=true;
      if(result.sections?.['xt26-cart-content'])document.dispatchEvent(new CustomEvent('xt26:cart-added',{detail:{html:result.sections['xt26-cart-content'],trigger:button}}));
      else location.assign(this.dataset.cartUrl);
    }catch(error){if(sent){this.locked=true;status.textContent=this.dataset.uncertain;this.querySelector('[data-xsr-cart-link]').hidden=false;}else status.textContent=error.message||this.dataset.error;}
    finally{this.busy=false;button.disabled=this.locked;button.removeAttribute('aria-busy');}
  }
});
  } catch(e) { console.error(e); }
})();

})();
